/** topcg/scr/routes.js  
 
    Define las rutas (paths) que accederá el programa, definiciendo las opciones que requieren autenticación.
    Desarrollado por JC Yocop
======================================================================================================== */    

/** Importaciones */
import chgpass      from './components/chgpass.vue'
import home         from './components/home.vue'
import login        from './components/login.vue'
import logout       from './components/logout.vue'
import culturaG     from './components/culturaG.vue'

/** Exportaciones */
export const routes = [
   
    /* Ejemplos sencillos de la relación de un path (/saludo, p.ej) con su respectivo componente  meta: { requiresAuth: true }  */    
    {path: '/',         name: 'home',       component: home,        meta: { requiresAuth: true }},
    {path: '/login',    name: 'login',      component: login,},    
    {path: '/chgpass',  name: 'chgpass',    component: chgpass,     meta: { requiresAuth: true }},
    {path: '/culturaG', name: 'culturaG',   component: culturaG,    meta: { requiresAuth: true }},
    {path: '/logout', component: logout, name: 'logout',            meta: { requiresAuth: true }},

    {path: '*', redirect: '/login'},       
];




// WEBPACK FOOTER //
// ./src/routes.js